import { turnsTileSiteKey } from '../constants/evs/TurnstileKey';

const TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export const loadTurnstileScript = () => {
  return new Promise((resolve, reject) => {
    if (
      window.turnstile ||
      document.querySelector(`script[src*="challenges.cloudflare.com/turnstile"]`)
    ) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = TURNSTILE_SCRIPT_URL;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Turnstile script'));

    document.head.appendChild(script);
  });
};

export const renderTurnstileWidget = (container, { onSuccess, onError }) => {
  const sitekey = turnsTileSiteKey;
  if (!sitekey) {
    //eslint-disable-next-line
    console.error('Turnstile: REACT_APP_TURNSTILE_SITE_KEY is not set');
    return null;
  }
  return window.turnstile.render(container, {
    sitekey,
    callback: onSuccess,
    'error-callback': onError,
    appearance: 'interaction-only',
    execution: 'execute'
  });
};
